<micro-aiBt-editor style="display: block;overflow: auto;" [bt]="bt"></micro-aiBt-editor>
